import { reportPurchaseConstants } from "../constants";

export const getReportPurchase = (pageNo, filterData) => {
    return {
        type: reportPurchaseConstants.GET_REPORT_PURCHASE,
        pageNo,
        filterData
    }
}
